import { createContext } from 'react';

import { Cart, Translations, Bundle, UiCategoryExt } from '../types';

export type AppContextType = {
    multilanguage: boolean;
    availableLanguages: {
        locale: string;
        selected: boolean;
        displayLanguage: string;
    }[];
    helpLink: string;
    translations: Translations;
    showSearch: boolean;
    showCart: boolean;
    showCategories: boolean;
    isArtificialCategoriesEnabled: boolean;
    categories: UiCategoryExt[];
    bonuspointsAvailable: boolean;
    mediaServerV2URL: string;
    bundle: Bundle;
    brand: string;
    domain: string;
    translationsLocale: string;
    hoppsSuggestionsUrl: string;
    vendorAssetsURL: string;
    cart: Cart;
    securityIconsHTML: string | null;
    locale: string;
    selectedShopLanguage?: string;
    isNextJS: boolean;
    siteId: number;
    originalHost: string;
    isLoggedIn: boolean;
    customerId: number;
    customerStatusLoaded: boolean;
    isError: boolean;
    searchFlyoutSponsoredTagEnabled: boolean;
    backendHeaderVersion: string;
    shippingInfoLink: string;
};

export const defaultContext: AppContextType = {
    multilanguage: false,
    availableLanguages: [],
    bonuspointsAvailable: true,
    helpLink: '',
    translations: new Map(),
    showSearch: true,
    showCategories: true,
    isArtificialCategoriesEnabled: false,
    categories: [],
    showCart: true,
    bundle: 'zooplus',
    brand: 'zooplus',
    mediaServerV2URL: '',
    cart: { summary: { articleCount: 0 } },
    securityIconsHTML: null,
    locale: 'de-DE',
    domain: '',
    translationsLocale: '',
    hoppsSuggestionsUrl: '',
    vendorAssetsURL: '',
    isNextJS: false,
    siteId: -1,
    originalHost: '',
    isLoggedIn: false,
    customerStatusLoaded: false,
    customerId: -1,
    isError: false,
    searchFlyoutSponsoredTagEnabled: false,
    backendHeaderVersion: '',
    shippingInfoLink: '',
};

const AppContext = createContext(defaultContext);

export default AppContext;
